let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6xiwL")).then(() => parcelRequire('fq2rP'));